import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

const ITEM_TYPE = 'TABLE_ROW';

const DraggableRow = ({ row, index, className, children, onMove, onClick }) => {
  const rowRef = useRef(null);
  const dragRef = useRef(null);

  // Drop target (entire row)
  const [, drop] = useDrop({
    accept: ITEM_TYPE,

    hover(item, monitor) {
      if (!rowRef.current) return;

      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) return;

      const hoverBoundingRect = rowRef.current.getBoundingClientRect();

      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      const clientOffset = monitor.getClientOffset();

      if (!clientOffset) return;

      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      // Dragging downward
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }

      // Dragging upward
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      onMove({
        dragIndex,
        hoverIndex,
      });

      item.index = hoverIndex;
    },
  });

  // Drag source (drag icon only)
  const [{ isDragging }, drag] = useDrag({
    type: ITEM_TYPE,

    item: () => ({
      index,
    }),

    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drop(rowRef);
  drag(dragRef);

  return (
    <tr
      ref={rowRef}
      className={className}
      // style={{
      //   opacity: isDragging ? 0.4 : 1,
      // }}
      onClick={(e) => {
        if (e.target.type === 'checkbox') return;
        onClick?.(row);
      }}
    >
      {React.Children.map(children, (child, childIndex) => {
        // Second column is the Drag column
        if (childIndex === 0) {
          return React.cloneElement(child, {
            ...child.props,
            children: (
              <div ref={dragRef} className='cursor-move'>
                {child.props.children}
              </div>
            ),
          });
        }

        return child;
      })}
    </tr>
  );
};

export default DraggableRow;
